import React from "react";
import { Link } from "react-router-dom";

function Breadcrump({ title, middle = "" }) {
  return (
     <div className="ith-breadcrumb-banner">
      <div
        className="ith-breadcrumb-banner__bg"
        style={{
          backgroundImage: `url("/assets/images/banner/breadcrumb.jpeg")`,
        }}
      />
      <div className="ith-breadcrumb-banner__overlay" />
      <div className="ith-breadcrumb-banner__content">
        <h1 className="ith-breadcrumb-banner__title">{title}</h1>
        <ol className="ith-breadcrumb-banner__nav">
          <li>
            <a href="/">Home</a>
          </li>
          <li>›</li>
          <li>{title}</li>
        </ol>
      </div>
    </div>
  );
}

export default Breadcrump;
